import { render } from "./invoiceItemAddDialog.vue?vue&type=template&id=57dea0ba&scoped=true"
import script from "./invoiceItemAddDialog.vue?vue&type=script&lang=js"
export * from "./invoiceItemAddDialog.vue?vue&type=script&lang=js"

import "./invoiceItemAddDialog.vue?vue&type=style&index=0&id=57dea0ba&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dea0ba"]])

export default __exports__